export default __webpack_public_path__ + "static/media/plus2.d4a7e4ea.svg";